<template>
  <full-screen-loader v-if="loading"/>
  <smd-one-col-layout v-else
                      class="m-root-medicine-order-details"
                      content-styles="full-width">

    <smd-header slot="header" nav>
      <span class="ns-icon-ico027"
            slot="left-actions"
            v-if="$isMobile"
            @click="goBack"/>
      <span class="ns-icon-ico027"
            slot="right-actions"
            v-else
            @click="goBack"/>
      <text-string :label-id="computedTitle"/>
      <span class="ns-icon-ico001"
            v-if="$isMobile"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <div v-if="displaySteps"
         class="m-root-medicine-order-details__step"
         slot="toolbar">
      <smd-step-progress :options="steps"
                         :current-step="currentStep"/>
    </div>

    <component v-if="serviceOrder"
               :service-order="serviceOrder"
               :watsons-branches="watsonBranches"
               :is="displayedComponent"
               :token="this.token"
               @refetch="fetchOrder">
    </component>
  </smd-one-col-layout>
</template>

<script>
  import RootMedicineOrderDetailsMixin from './root-medicine-order-details-mixin';

  export default {
    name: 'm-root-medicine-order-details',
    mixins: [RootMedicineOrderDetailsMixin]
  }
</script>
